import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import './HomeMoreInfos.css';

const HomeMoreInfos = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const allSlides = [
    {
      src: "/img/slider_5.jpg", 
      alt: "Nintschew & Partner – Professional Services",
      showOn: "both"
    },
    {
      src: "/img/slider_4.jpg",
      alt: "Nintschew & Partner – Business Consulting",
      showOn: "both"
    },
    {
      src: "/img/slider_3.jpg",
      alt: "Nintschew & Partner – Desktop View",
      showOn: "desktop"
    },
    {
      src: "/img/slider_7.jpg",
      alt: "Nintschew & Partner – Mobile View",
      showOn: "mobile"
    },
    {
      src: "/img/slider_10.jpg",
      alt: "Nintschew & Partner – Beratung im Team",
      showOn: "both"
    },
    {
      src: "/img/slider_11.jpg",
      alt: "Nintschew & Partner – Büro",
      showOn: "both"
    },
  ];

  const slides = allSlides.filter(slide => {
    if (slide.showOn === "both") return true;
    if (slide.showOn === "desktop" && !isMobile) return true;
    if (slide.showOn === "mobile" && isMobile) return true;
    return false;
  });

  return (
    <section className="home-more-infos" id="more">
      <div className="home-more-infos__hero">
        <Swiper
          modules={[Autoplay, EffectFade, Navigation]}
          effect="fade"
          fadeEffect={{
            crossFade: true
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          }}
          navigation={{
            prevEl: '.home-more-infos__nav-prev',
            nextEl: '.home-more-infos__nav-next',
          }}
          loop={true}
          speed={800}
          className="home-more-infos__slider"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={`${slide.src}-${index}`}>
              <img
                src={slide.src}
                alt={slide.alt}
                className="home-more-infos__hero-image"
              />
            </SwiperSlide>
          ))}
        </Swiper>
        
        {/* Navigation Buttons */}
        <button className="home-more-infos__nav-btn home-more-infos__nav-prev" aria-label="Previous image">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <button className="home-more-infos__nav-btn home-more-infos__nav-next" aria-label="Next image">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </section>
  );
};

export default HomeMoreInfos;


